<template id="navPart">
  <div>
    <div
      class="nav"
      :class="{
        scrollBg:
          !navHead ||
          (navName == 'yogaPracticeClassify' && !isMobile) ||
          (navName == 'yogaPracticePlan' && !isMobile),
      }"
    >
      <div class="content clearfix">
        <div class="pull-left mobile-nav-head">
          <img
            @click="goHome"
            v-show="
              !(
                !navHead ||
                (navName == 'yogaPracticeClassify' && !isMobile) ||
                (navName == 'yogaPracticePlan' && !isMobile)
              )
            "
            class="logo"
            src="../assets/img/logo.png"
            alt="每日瑜伽专业瑜伽教学平台"
          />
          <img
            @click="goHome"
            v-show="
              !navHead ||
                (navName == 'yogaPracticeClassify' && !isMobile) ||
                (navName == 'yogaPracticePlan' && !isMobile)
            "
            class="logo"
            src="../assets/img/logo2.png"
            alt="每日瑜伽专业瑜伽教学平台"
          />
          <p
            class="navbar-toggle"
            :class="{ 'bg-white': !isModileNav }"
            @click="mShowNav()"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </p>
        </div>
        <div
          class="pull-right mobile-nav relative"
          @click="mobileNavGo()"
          :class="{ 'hide-m': isModileNav }"
        >
          <ul class="pull-left">
            <li class="pull-left">
              <router-link
                class="white"
                :to="{ name: 'index', query: $route.query }"
                :class="{ active: nav == 'index' }"
                >首页</router-link
              >
            </li>
            <li class="pull-left yoga-menu-li">
              <router-link
                class="white"
                :to="{ name: 'yogaPractice' }"
                :class="{ active: nav == 'yogaPractice' }"
                >瑜伽练习</router-link
              >
              <!-- <div class="yoga-menu hide-m">
                <div>
                  <p>
                    基础系列
                    <router-link
                      :to="{ name: 'yogaPractice' }"
                      class="all"
                      href="javascript:;"
                      >查看全部></router-link
                    >
                  </p>
                  <ul class="clearfix">
                    <template v-for="(i, index) in category">
                      <li :key="index" v-if="index < 9">
                        <a
                          @click="
                            goClassify(i)
                          "
                          href="javascript:;"
                          >{{ i.layer_text }}</a
                        >
                      </li>
                    </template>
                  </ul>
                </div>
                <div>
                  <p>名师课堂</p>
                  <ul class="clearfix">
                    <template v-for="(i, index) in program">
                      <li :key="index" v-if="index < 6">
                        <a
                          @click="goPlan(i.program_id, i.cn_spell_name)"
                          href="javascript:;"
                          >{{ i.program_name }}</a
                        >
                      </li>
                    </template>
                  </ul>
                </div>
              </div> -->
            </li>
            <li class="pull-left yoga-menu-li">
              <router-link
                class="white"
                :to="{ name: 'yogaUniversityTrain' }"
                :class="{ active: nav == 'yogaUniversity' }"
                >主题训练营</router-link
              >
            </li>
            <!-- <li class="pull-left yoga-menu-li">
              <router-link
                class="white"
                :to="{ name: 'yogaUniversityRyt' }"
                :class="{ active: nav == 'yogaUniversity' }"
                >线下培训</router-link
              >
              <div class="yoga-menu university hide-m">
                <ul class="clearfix">
                  <li>
                    <router-link :to="{ name: 'yogaUniversityRyt' }"
                      >RYT教学培训</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'yogaUniversityWorkshop' }"
                      >工作坊</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'yogaUniversityLearnto' }"
                      >游学</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'yogaUniversityTrain' }"
                      >主题训练营</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'yogaUniversityCredential' }"
                      >证书查询</router-link
                    >
                  </li>
                </ul>
              </div>
            </li> -->
            <li class="pull-left yoga-menu-li">
              <router-link
                class="white"
                :to="{ name: 'teacherCooperation' }"
                :class="{ active: nav == 'teacherCooperation' }"
                >合作名师</router-link
              >
              <!-- <div class="yoga-menu teacher hide-m">
                <ul class="clearfix">
                  <template v-for="(i, index) in coach">
                    <li :key="index" v-if="index < 13">
                      <a
                        @click="coachDetail(i.coach_id, i.cn_spell_name)"
                        href="javascript:;"
                      >
                        <img :src="i.coach_logo" :alt="i.coach_name" />
                        <span class="ellipsis-only" style="display: block">{{
                          i.coach_name
                        }}</span>
                      </a>
                    </li>
                  </template>

                  <li>
                    <router-link
                      :to="{ name: 'teacherCooperation' }"
                      class="all"
                      >查看全部</router-link
                    >
                  </li>
                </ul>
              </div> -->
            </li>
            <!-- <li class="pull-left">
              <router-link
                style="margin-right: 0"
                class="white"
                :to="{ name: 'mall' }"
                :class="{ active: nav == 'mall' }"
                >装备</router-link
              >
            </li> -->
            <!-- <li class="pull-left">

              <p v-if="!userMsg"><a rel="nofollow" class="white" href="javascript:;" @click="login(1)">登录</a>|<a rel="nofollow"  @click="login(2)" class="white" href="javascript:;">注册</a></p>

              <p v-if="userMsg"><img v-if="userMsg.logo && userMsg.logo.small" :src="userMsg.logo.small" class="user" alt="每日瑜伽专业瑜伽教学平台"> <img v-if="!userMsg.logo || !userMsg.logo.small" src="http://qiniucdn.dailyyoga.com.cn/07/be/07be96c1f886841a5b8efd1b6fb7720f.png" class="user" alt="每日瑜伽专业瑜伽教学平台" ><a class="white" href="javascript:;" @click="logOut()">登出</a></p>
            </li> -->
          </ul>
        </div>
      </div>
    </div>

    <div
      class="mask hide-m"
      :class="{ hide: loginHide }"
      @click.self="hideLogin()"
    ></div>
    <div class="login-box" :class="{ hide: loginHide }">
      <div class="login clearfix">
        <p class="option">
          <span
            rel="nofollow"
            @click="login(1)"
            :class="{ active: isLogIn == 1 || isLogIn == 0 }"
            >登录</span
          >
          <span
            rel="nofollow"
            @click="login(2)"
            :class="{ active: isLogIn == 2 }"
            >注册</span
          >
        </p>
        <div class="scan hide-m">
          <div @click="login(0)" v-show="isLogIn == 1">
            <div class="way-box">
              <img
                src="../assets/img/erweima.png"
                alt="每日瑜伽专业瑜伽教学平台"
              />
              <div class="way"></div>
            </div>
            <p class="tips">
              扫码登录更安全 <span class="border"></span><span></span>
            </p>
          </div>

          <img
            @click="login(1)"
            v-show="isLogIn == 0"
            class="desktop"
            src="../assets/img/icon_pc.png"
            alt="每日瑜伽专业瑜伽教学平台"
          />
        </div>
        <div v-show="isLogIn >= 1">
          <ul class="clearfix">
            <li v-show="isLogIn == 1" class="border clearfix">
              <i class="phone"></i>
              <input
                @blur="verify('username')"
                v-model="loginData.username"
                placeholder="手机号"
                class="pull-left"
                type="text"
                name=""
              />
            </li>
            <li v-show="isLogIn == 2" class="border clearfix">
              <i class="phone"></i>
              <input
                @blur="verify('username2')"
                v-model="loginData.username2"
                placeholder="手机号"
                class="pull-left"
                type="text"
                name=""
              />
            </li>
            <li v-show="isLogIn == 2 && !isVerify" class="clearfix security">
              <div class="clearfix pull-left security">
                <i class="security"></i>
                <input
                  v-model="loginData.verify_code"
                  placeholder="验证码"
                  class="pull-left"
                  type="text"
                  name=""
                />
              </div>
              <button
                v-show="!timeShow"
                id="securityBtn"
                @click="verifyCode()"
                class="pull-left security"
              >
                发送验证码
              </button>
              <button v-show="timeShow" class="pull-left security blue">
                {{ count }} s
              </button>
            </li>
            <li v-show="isLogIn == 1" class="border clearfix">
              <i class="password"></i>
              <input
                v-model="loginData.password"
                placeholder="密码"
                class="pull-left"
                type="password"
                name=""
                @keydown="logIn($event)"
              />
            </li>
            <li v-show="isLogIn == 2 && !isVerify" class="border clearfix">
              <i class="password"></i>
              <input
                v-model="loginData.password2"
                @blur="verify('password')"
                placeholder="密码 6-12位数字、字母、下划线"
                class="pull-left"
                type="password"
                name=""
              />
            </li>
            <li>
              <p class="error">{{ errorTips }}</p>
            </li>
            <li>
              <button rel="nofollow" v-show="isLogIn == 1" @click="logIn()">
                登录
              </button>
              <button
                rel="nofollow"
                v-show="isLogIn == 2 && !isVerify"
                @click="register()"
              >
                注册
              </button>
            </li>
          </ul>

          <div v-if="registerText" class="load-mask">
            <div class="loading">
              <div>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>

          <ul v-show="isVerify" class="verify">
            <li class="clearfix">
              <img :src="verifyImg" alt="每日瑜伽专业瑜伽教学平台" />
              <span @click="refreshsecCode()">看不清楚,刷新</span>
            </li>
            <li class="border clearfix">
              <input
                v-model="secCode"
                placeholder="请输入上图内容"
                class="pull-left"
                type="text"
                name=""
              />
            </li>
            <li>
              <button @click="sendSecCode()">确定</button>
            </li>
          </ul>
        </div>

        <div class="qr-code" v-show="isLogIn < 1">
          <p>手机扫码，安全登录</p>
          <div id="loginCode"></div>
          <b>打开每日瑜伽APP — 个人 — 扫一扫登录</b>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '../assets/style/variable';

.load-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.loading {
  width: 120px;
  height: 80px;
  background: #404040;
  border-radius: 5px;

  position: absolute;
  top: 50%;
  margin-top: -40px;
  left: 50%;
  margin-left: -60px;

  div {
    width: 50px;
    height: 10px;
    margin: 0 auto;
    position: relative;
    top: 30px;
  }
}
.loading span {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  border-radius: 50%;
  background: #fff;
  -webkit-animation: load 1.04s ease infinite;
}
.loading span:last-child {
  margin-right: 0px;
}
@-webkit-keyframes load {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.loading span:nth-child(1) {
  -webkit-animation-delay: 0.13s;
}

.loading span:nth-child(2) {
  -webkit-animation-delay: 0.26s;
}

.loading span:nth-child(3) {
  -webkit-animation-delay: 0.39s;
}

.yoga-menu-li .yoga-menu {
  display: none !important;
}

.yoga-menu-li:hover .yoga-menu {
  display: block !important;
}

.login {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1001;
  background: $blue-lighter;
  padding: 30px;
  width: 380px;
  transform: translate(-50%, -50%);
  border-radius: 5px;

  .option {
    font-size: $font-size-h1;
    margin-bottom: 25px;

    span {
      padding-bottom: 5px;
      display: inline-block;
      color: $gray-dark;
      margin-right: 10px;
    }

    span.active {
      border-bottom: 3px solid $gray-darker;
      color: $gray-darker;
    }
  }

  .scan {
    position: absolute;
    right: 0;
    top: 0;
    min-width: 80px;
    .way-box {
      width: 80px;
      height: 80px;
      position: absolute;
      right: 0;
      top: 0;
      overflow: hidden;
    }
    .way {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 0;
      line-height: 0;
      border-width: 80px;
      border-color: $blue-lighter;
      border-right-width: 0;
      border-style: dashed;
      border-left-style: solid;
      border-top-color: transparent;
      border-bottom-color: transparent;
    }

    img {
      width: 80px;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    .tips {
      position: relative;
      margin-top: 30px;
      margin-right: 60px;
      font-size: $font-size-small;
      padding: 5px;
      color: #dd9b31;
      background: #fefcef;
      border: 1px solid #b6974c;

      span {
        display: block;
        border-width: 6px;
        border-color: #fefcef;
        border-right-width: 0;
        border-style: dashed;
        border-left-style: solid;
        border-top-color: transparent;
        border-bottom-color: transparent;
        position: absolute;
        top: 5px;
        right: -6px;
      }

      span.border {
        border-width: 8px;
        border-color: #b6974c;
        border-right-width: 0;
        border-style: dashed;
        border-left-style: solid;
        border-top-color: transparent;
        border-bottom-color: transparent;
        position: absolute;
        top: 3px;
        right: -8px;
      }
    }

    img.desktop {
      width: 40px;
      margin: 10px;
    }
  }

  .qr-code {
    text-align: center;
    p {
      font-size: $font-size-b3;
      color: $gray-darker;
    }
    b {
      font-size: $font-size-large;
      color: $gray-dark;
    }
    img {
      width: 200px;
      margin: 20px auto;
    }
  }

  li {
    margin-bottom: 20px;
    position: relative;
    box-sizing: border-box;
  }

  li.border {
    border: 1px solid #979797;
  }

  li i {
    @include icon(
      $width: 23px,
      $height: 28px,
      $url: '../assets/img/icon_yanz.png'
    );
    transform: translate(0, 30%);
    padding: 0 8px;
    position: absolute;
    left: 0;
  }

  li i.phone {
    width: 20px;
    height: 30px;
    background-image: url('../assets/img/icon_iphone.png');
    background-size: 20px 30px;
  }

  li i.password {
    background-image: url('../assets/img/icon_mima.png');
  }

  div.import-box {
    float: left;
  }

  input {
    box-sizing: border-box;
    width: 100%;
    height: 45px;
    border: none;
    text-indent: 45px;
    font-size: $font-size-large;
  }

  button {
    display: block;
    width: 100%;
    height: 47px;
    border: 1px solid $blue;
    background: $blue;
    color: $white;
    font-size: $font-size-large;
  }

  button.gray {
    background: #e5e5e5;
    border: 1px solid #c8c8c8;
    color: #999;
  }

  button.security {
    width: 110px;
    background: #e5e5e5;
    border: 1px solid #c8c8c8;
    color: #999;
    margin-left: 10px;
  }

  button.security.blue {
    border: 1px solid $blue;
    color: $blue;
  }

  div.security {
    width: 260px;
    box-sizing: border-box;
    border: 1px solid #979797;
  }

  .verify {
    img {
      width: 155px;
      display: inline-block;
      border: 2px solid #fff;
    }

    span {
      text-decoration: underline;
      position: relative;
      top: -5px;
      left: 10px;
      cursor: pointer;
    }

    input {
      text-indent: 10px;
    }
  }
}
.nav {
  transition: background 0.5s;
  transition-timing-function: ease-in-out;
  width: 100%;
  padding: 17px 0;
  position: fixed;
  top: 0;
  z-index: 999;
  line-height: 45px;
  font-size: $font-size-h2;
  color: $white;
  background: url('../assets/img/01.png');
  a.white {
    color: $white;
    margin-right: 30px;
  }
  p a.white {
    margin-right: 5px;
    margin-left: 5px;
  }

  a.active {
    padding-bottom: 5px;
    border-bottom: 4px solid #fff;
  }

  img.user {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    float: left;
    margin-right: 5px;
  }
}

.scrollBg {
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
  color: $gray-darker;

  a.white {
    color: $gray-darker;
  }

  a.active {
    border-color: $gray-darker;
  }
}

.yoga-menu {
  position: absolute;
  background: #f5f5f5;
  color: $gray-darker;
  width: 580px;
  padding: 15px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);

  ul {
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    border-top: 1px solid #f0f0f0;
  }
  li {
    width: 33%;
    float: left;
    font-size: $font-size-baser;
    a {
      border-left: 4px solid $gray-darker;
      padding-left: 10px;
    }
  }

  a.all {
    color: $blue;
    font-size: $font-size-baser;
    float: right;
  }
}

.university.yoga-menu {
  width: 180px;
  ul {
    padding: 0;
    padding-left: 10px;
    border: none;
  }
  li {
    float: none;
    width: 100%;
  }
}

.teacher.yoga-menu {
  position: absolute;
  right: 0;
  width: 440px;
  ul {
    padding: 0;
    padding-top: 10px;
  }
  li {
    width: 20%;
    text-align: center;
    margin-bottom: 10px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 35px;
      margin: 0 auto;
      margin-bottom: 10px;
    }

    a {
      display: block;
      border: none;
      line-height: 1.2;
      font-size: $font-size-base;
    }
  }

  a.all {
    padding: 0;
    display: block;
    width: 70px;
    height: 70px;
    border-radius: 35px;
    background: #d8d8d8;
    color: $gray-darker;
    font-size: $font-size-small;
    float: right;
    line-height: 70px;
  }
}

@media (max-width: $screen-lm) {
  .login-box {
    background: $blue-lighter;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: 98;
  }

  .yoga-menu-li .yoga-menu {
    display: none !important;
  }

  .yoga-menu-li:hover .yoga-menu {
    display: none !important;
  }

  .login {
    padding: 0px;
    width: 300px;
    z-index: 98;

    .option {
      font-size: $font-size-h2;
    }

    input,
    button {
      font-size: $font-size-base;
    }

    button.security {
      width: 100px;
    }

    div.security {
      width: 190px;
    }
  }

  .nav {
    background: #fff;
    padding: 14px 0;
    .content {
      width: 100%;
      padding: 0;
    }
    .logo {
      width: 100px;
      margin-left: 15px;
    }

    a.white {
      margin-right: 0;
    }

    .navbar-toggle {
      position: absolute;
      top: 0;
      right: 15px;
    }

    .icon-bar {
      display: block;
      width: 22px;
      height: 2px;
      border-radius: 1px;
      background: $gray-base;
      margin-top: 4px;
    }

    .bg-white .icon-bar {
      background: $white;
    }

    img.user {
      float: none;
      vertical-align: middle;
      display: inline-block;
    }
  }

  .mobile-nav-head {
    position: relative;
    z-index: 999;
    width: 100%;
  }

  .mobile-nav {
    background: rgba(0, 0, 0, 0.8);
    width: 100%;
    height: 100%;
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 99;
    ul {
      width: 100%;
      position: absolute;
      top: 50%;
      margin-top: -160px;
      text-align: center;
    }
    ul li {
      float: none !important;
      padding: 5px 0;
    }

    a {
      color: $white;
    }

    a.active {
      border-color: $white;
    }
  }
}
</style>

<script>
import DY from '../assets/js/common';
import { goDetailFun } from '../assets/js/jump';
import qs from 'qs';
import QRCode from '../../node_modules/qrcodejs2/qrcode';

const TIME_COUNT = 60;

function changNavFun(name) {
  if (!!name) {
    if (name.indexOf('mall') != -1) {
      return 'mall';
    }
    if (name.indexOf('yogaPractice') != -1) {
      return 'yogaPractice';
    }
    if (name.indexOf('yogaUniversity') != -1) {
      return 'yogaUniversity';
    }
    if (name.indexOf('teacherCooperation') != -1) {
      return 'teacherCooperation';
    }
    return 'index';
  }

  return 'index';
}

export default {
  name: 'partNav',
  beforeCreate() {
    if (!DY.isMobile) {
      //获取基础练习分类
      this.$axios
        .get(DY.baseUrl + 'practice/basic_series')
        .then((rsp) => {
          if (rsp.data.error_code == 0) {
            this.category = rsp.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      //名师课堂
      this.$axios
        .get(DY.baseUrl + 'practice/program?series_type=2')
        .then((rsp) => {
          if (rsp.data.error_code == 0) {
            this.program = rsp.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      //获取教练列表
      this.$axios
        .get(DY.baseUrl + 'yoga_coach/GetCoachList')
        .then((rsp) => {
          if (rsp.data.error_code == 0) {
            var coach = rsp.data.result;

            for (var i = 0; i < coach.length; i++) {
              for (var j = 0; j < coach[i].list.length; j++) {
                this.coach.push(coach[i].list[j]);
              }
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  data() {
    return {
      coach: [],
      category: '',
      program: '',
      msg: '主菜单',
      nav: changNavFun(this.$route.name),
      navName: this.$route.name,
      navHead: DY.isMobile ? 0 : 1,
      isMobile: DY.isMobile ? 1 : 0,
      isModileNav: 1,
      yogaNav: [1, 1, 1],
      isLogIn: 1,
      loginHide: 1,
      loginData: {},
      errorTips: '',
      isVerify: 0,
      verifyImg: DY.baseUrl + 'user/register/verifycode/img',
      userMsg: window.localStorage.user
        ? JSON.parse(window.localStorage.user)
        : '',
      secCode: '',
      timeShow: 0,
      count: '',
      timer: null,
      qr_string: '',
      qr_type: '',
      qr_url: '',
      qr_timer: null,
      registerText: 0,
    };
  },
  watch: {
    $route: 'changeNav',
  },
  methods: {
    goClassify(item) {
      if(item.url_content) {
        if(item.url_content.substr(0,7) == "http://" || item.url_content.substr(0,8) == "https://") {
          window.open(item.url_content);
        }else {
          var url = 'http://' + item.url_content;
          window.open(url);
        }
      }
      // let { query } = this.$route,
      //   params = {
      //     id: id,
      //     title: title,
      //     img: img,
      //     cn_spell_name: cn_spell_name,
      //   };
      // this.$router.push({
      //   name: 'yogaPracticeClassify',
      //   params: params,
      //   query: query,
      // });
    },
    goPlan(id, cn_spell_name) {
      var params = { id: id, cn_spell_name: cn_spell_name };
      goDetailFun(this, 'yogaPracticePlan', params);
    },
    coachDetail(id, cn_spell_name) {
      var params = { id: id, cn_spell_name: cn_spell_name.replace(/\s/g, '') };
      goDetailFun(this, 'teacherCooperationDetail', params);
    },
    register() {
      //注册
      if (!this.loginData.username2) {
        this.errorTips = '请输入手机号';
        return '';
      }

      if (!/^1[34578]\d{9}$/.test(this.loginData.username2)) {
        this.errorTips = '请输入正确的手机号';
        return '';
      }

      if (!this.loginData.verify_code) {
        this.errorTips = '请输入验证码';
        return '';
      }

      if (!this.loginData.password2) {
        this.errorTips = '请设置密码';
        return '';
      }

      if (!/^[\w]{6,12}$/.test(this.loginData.password2)) {
        this.errorTips = '密码至少6个字符，只能包含数字、字母、下划线';
        return '';
      }

      if (this.registerText == 0) {
        this.registerText = 1;
        this.$axios
          .post(
            DY.baseUrl + 'user/register',
            qs.stringify({
              username: this.loginData.username2,
              password: this.loginData.password2,
              verify_code: this.loginData.verify_code,
            }),
          )
          .then((rsp) => {
            this.registerText = 0;
            if (rsp.data.error_code != 0) {
              this.errorTips = rsp.data.error_desc;
              return;
            }
            var rspdata = {
              logo: rsp.data.result.logo,
              name: rsp.data.result.nickName,
              sid: rsp.data.result.sid,
            };
            window.localStorage.user = JSON.stringify(rspdata);
            this.userMsg = rspdata;
            this.loginHide = 1;
            this.loginData = {};

            $('.toast').show();

            setTimeout(function() {
              $('.toast').hide();
            }, 3000);
          })
          .catch(function(error) {
            this.registerText = 0;
            console.log(error);
          });
      }
    },
    refreshsecCode() {
      this.verifyImg =
        DY.baseUrl + 'user/register/verifycode/img?=' + new Date().getTime();
    },
    sendSecCode() {
      if (this.secCode && this.loginData.username2) {
        this.$axios
          .post(
            DY.baseUrl + 'user/register/verifycode/send',
            qs.stringify({
              username: this.loginData.username2,
              verify_code: this.secCode,
            }),
          )
          .then((rsp) => {
            if (rsp.data.error_code != 0) {
              this.errorTips = rsp.data.error_desc;
              return;
            }

            this.errorTips = '';

            this.isVerify = 0;

            if (!this.timer) {
              this.count = TIME_COUNT;
              this.timeShow = 1;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.timeShow = 0;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    mShowNav() {
      this.isModileNav = !this.isModileNav;
      this.navHead = !this.navHead;
    },
    changeNav() {
      this.nav = changNavFun(this.$route.name);
      this.loginHide = 1;
      this.navName = this.$route.name;

      if (this.nav == 'yogaUniversity') {
        if (this.$route.name == 'yogaUniversityCredential') {
          $('#newBridge').hide();
          return '';
        }
        $('#newBridge').show();
      } else {
        $('#newBridge').hide();
      }
    },
    handleScroll() {
      var bannerHeight = this.$route.name == 'index' ? 900 : 450;

      if (!DY.isMobile) {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;

        if (scrollTop >= bannerHeight) {
          this.navHead = 0;
          return;
        }
        this.navHead = 1;
      }
    },
    mobileNavGo() {
      if (DY.isMobile) {
        this.navHead = 0;
        this.isModileNav = 1;
      }
    },
    login(type) {
      this.errorTips = '';
      this.isLogIn = type;
      this.loginHide = 0;
      this.isVerify = 0;

      $('#loginCode').html('');

      //扫码登录
      if (type == 0) {
        var that = this;
        this.$axios
          .get(DY.baseUrl + 'user/login/qr_code', {
            params: {
              version: '3.1.0',
            },
          })
          .then((rsp) => {
            if (rsp.data.error_code != 0) {
              this.errorTips = rsp.data.error_desc;
              return;
            }
            this.qr_url = rsp.data.result.result.qr_url.replace('o2o.', 'www.');
            this.qr_string = rsp.data.result.result.qr_string;
            clearInterval(this.qr_timer);

            var qrcode = new QRCode('loginCode', {
              width: 300,
              height: 300,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H,
            });

            qrcode.makeCode(this.qr_url);

            this.qr_timer = setInterval(() => {
              this.$axios
                .get(
                  DY.baseUrl +
                    'user/login/qr_code/check?qr_string	=' +
                    this.qr_string,
                )
                .then((rsp) => {
                  if (rsp.data.result.result != '') {
                    clearInterval(this.qr_timer);

                    this.$axios
                      .post(
                        DY.baseUrl + 'user/login',
                        qs.stringify({
                          sid: rsp.data.result.result,
                        }),
                      )
                      .then((rsp) => {
                        if (rsp.data.error_code != 0) {
                          this.errorTips = rsp.data.error_desc;
                          return;
                        }
                        var rspdata = {
                          logo: rsp.data.result.logo,
                          name: rsp.data.result.nickName,
                          sid: rsp.data.result.sid,
                        };
                        window.localStorage.user = JSON.stringify(rspdata);
                        this.userMsg = rspdata;
                        this.loginHide = 1;
                        this.loginData = {};
                      })
                      .catch(function(error) {
                        console.log(error);
                      });
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            }, 2000);
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        clearInterval(this.qr_timer);
      }
    },
    hideLogin() {
      if (this.registerText == 0) {
        this.loginHide = 1;
      }

      this.loginData = {};
      clearInterval(this.qr_timer);
    },
    logIn(ev) {
      //登录
      if (ev && ev.keyCode != 13) {
        return;
      }

      if (!this.loginData.username) {
        this.errorTips = '请输入手机号码';
        return;
      }

      if (!this.loginData.password) {
        this.errorTips = '请输入密码';
        return;
      }

      if (!/^1[34578]\d{9}$/.test(this.loginData.username)) {
        this.errorTips = '请输入正确的手机号';
        return;
      }

      this.errorTips = '';

      this.$axios
        .post(
          DY.baseUrl + 'user/login',
          qs.stringify({
            username: this.loginData.username,
            password: this.loginData.password,
          }),
        )
        .then((rsp) => {
          if (rsp.data.error_code != 0) {
            this.errorTips = rsp.data.error_desc;
            return;
          }
          var rspdata = {
            logo: rsp.data.result.logo,
            name: rsp.data.result.nickName,
            sid: rsp.data.result.sid,
          };
          window.localStorage.user = JSON.stringify(rspdata);
          this.userMsg = rspdata;
          this.loginHide = 1;
          this.loginData = {};
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    logOut() {
      //登出
      var sid = this.userMsg.sid;

      this.$axios
        .get(DY.baseUrl + 'user/logout?sid=' + sid)
        .then((rsp) => {
          window.localStorage.user = '';
          this.userMsg = '';
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    verifyCode() {
      this.secCode = '';

      if (!this.loginData.username2) {
        this.errorTips = '请输入手机号码';
        return;
      }

      if (!/^1[34578]\d{9}$/.test(this.loginData.username2)) {
        this.errorTips = '请输入正确的手机号';
        return;
      }

      this.isVerify = 1;
      this.verifyImg =
        DY.baseUrl + 'user/register/verifycode/img?=' + new Date().getTime();
    },
    verify(type) {
      if (type == 'username' && this.loginData.username) {
        if (!/^1[34578]\d{9}$/.test(this.loginData.username)) {
          this.errorTips = '请输入正确的手机号';
        } else {
          this.errorTips = '';
        }
      }

      if (type == 'username2' && this.loginData.username2) {
        if (!/^1[34578]\d{9}$/.test(this.loginData.username2)) {
          this.errorTips = '请输入正确的手机号';

          $('#securityBtn').removeClass('blue');
        } else {
          this.errorTips = '';
          this.verifyImg =
            DY.baseUrl +
            'user/register/verifycode/img?=' +
            new Date().getTime();
          $('#securityBtn').addClass('blue');
        }
      }

      if (type == 'password' && this.loginData.password2) {
        if (!/^[\w]{6,12}$/.test(this.loginData.password2)) {
          this.errorTips = '密码至少6个字符，只能包含数字、字母、下划线';
        } else {
          this.errorTips = '';
        }
      }
    },

    goHome() {
      this.$router.push({ name: 'index' });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/partNav.vue